/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Purchases_RestoredInputs */

const en_plan_purchases_restored = /** @type {(inputs: Plan_Purchases_RestoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchases restored`)
};

const es_plan_purchases_restored = /** @type {(inputs: Plan_Purchases_RestoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compras restauradas`)
};

/**
* | output |
* | --- |
* | "Purchases restored" |
*
* @param {Plan_Purchases_RestoredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_purchases_restored = /** @type {((inputs?: Plan_Purchases_RestoredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Purchases_RestoredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_purchases_restored(inputs)
	return en_plan_purchases_restored(inputs)
});